import { useDispatch } from 'react-redux';
import { Action, Dispatch } from 'redux';
import * as HistoryService from '../base/historyService';
import FeedbackWidget from '../components/FeedbackWidget/FeedbackWidget';
import './FeedbackPopup.scss';
import { feedbackTrackingAction } from './firebaseActions';

interface IFeedbackPopupProps {
  show: boolean;
}

export default function FeedbackPopup({ show }: Readonly<IFeedbackPopupProps>) {
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  if (!show) {
    return null;
  }
  const feedbackHandler = (feedback: 0 | 1) => {
    // track feedback on firebase
    dispatch(feedbackTrackingAction(feedback ? 'up' : 'down'));
    // redirect to dashboard
    HistoryService.redirectInternal('/');
  };
  return (
    <div className="welcome-feedback-widget">
      <FeedbackWidget onFeedback={feedbackHandler} titleId={'Welcome.Tour.Feedback'} />
    </div>
  );
}
